<template>
  <div>
    <Import
      title="Customer"
      :check_validation="'customer/importcustomervalidation'"
      :url="url"
      :items="items"
      @import="submit"
      :show_message="''"
      :sample_file_name="'sample-customer-data.xlsx'"
      :show_dup_handle="{
        show:true,
        value:0}"
        @redirectPage="redirectPage"
    ></Import>
  </div>
</template>
<script>
import Import from "@/components/Form/Import/Import";
import sample_data from "@/assets/sample-import-files/sample-customer.xlsx";
import { mapState, mapGetters } from "vuex";
export default {
  components: { Import, sample_data },
  data() {
    return {
      url: sample_data,
      items: this.import_columns()
    };
  },
  created() {
    if (this.cus_settings_details.custom_field.length > 0) {
      var temp = this;
      this.cus_settings_details.custom_field.map(function(value) {
        if (value.created == 1 && value.status == 1) {
          temp.items.push({
            actual_label: value.label_name,
            excel_label: "",
            is_required: value.is_required == 1 ? true : false,
            unique: 0,
            field_name: value.field_name,
            datatype:
              value.datatype == "checkbox"
                ? "select"
                : value.datatype == "url" ||
                  value.datatype == "email" ||
                  value.datatype == "textarea"
                ? "text"
                : value.datatype,
            max:
              value.datatype == "decimal" || value.datatype == "amount"
                ? 10000000000000
                : value.datatype == "date" ||
                  value.datatype == "select" ||
                  value.datatype == "checkbox"
                ? ""
                : 100,
            min: value.datatype == "percent" ? 0 : ""
          });
        }
      });
    }
    if (this.enablepricelist.is_price_list_enabled == 1) {
      this.items.push({
        actual_label: "Price List",
        excel_label: "",
        is_required: false,
        unique: 0,
        field_name: "pricing_hdr_id",
        datatype: "select",
        max: 0,
        min: 0
      });
    }
  },
  methods: {
    redirectPage(){
      this.$router.push({name:'Customer'})
    },
    import_columns() {
      return [
        {
          actual_label: "Customer Type",
          excel_label: "",
          field_name: "cus_type",
          is_required: true,
          unique: 0,
          datatype: "select",
          max: 0,
          min: 0
        },
        {
          actual_label: "First Name",
          excel_label: "",
          field_name: "cus_fname",
          is_required: false,
          unique: 0,
          datatype: "text",
          max: 30,
          min: 0
        },
        {
          actual_label: "Last Name",
          excel_label: "",
          field_name: "cus_lname",
          is_required: false,
          unique: 0,
          datatype: "text",
          max: 30,
          min: 0
        },
        {
          actual_label: "Company Name",
          excel_label: "",
          field_name: "cus_comp_name",
          is_required: false,
          unique: 0,
          datatype: "text",
          max: 150,
          min: 0
        },
        {
          actual_label: "Customer ID",
          excel_label: "",
          field_name: "cus_legacy_id",
          is_required: false,
          unique: 1,
          datatype: "text",
          max: 15,
          min: 0
        },
        {
          actual_label: "Display Name",
          excel_label: "",
          field_name: "cus_display_name",
          is_required: true,
          unique: 1,
          datatype: "text",
          max: 150,
          min: 0
        },
        {
          actual_label: "EmailID",
          excel_label: "",
          field_name: "cus_mail",
          is_required: false,
          unique: 1,
          datatype: "text",
          max: 100,
          min: 0
        },
        {
          actual_label: "Phone",
          excel_label: "",
          field_name: "cus_ph_no_1",
          is_required: false,
          unique: 1,
          datatype: "number",
          max: 10,
          min: 0
        },
        {
          actual_label: "Facebook",
          excel_label: "",
          field_name: "cus_facebook_id",
          is_required: false,
          unique: 0,
          datatype: "text",
          max: 30,
          min: 0
        },
        {
          actual_label: "Twitter",
          excel_label: "",
          field_name: "cus_twitter_id",
          is_required: false,
          unique: 0,
          datatype: "text",
          max: 30,
          min: 0
        },
        {
          actual_label: "Website",
          excel_label: "",
          field_name: "cus_website",
          is_required: false,
          unique: 0,
          datatype: "text",
          max: 255,
          min: 0
        },
        {
          actual_label: "Notes",
          excel_label: "",
          field_name: "cus_notes",
          is_required: false,
          datatype: "text",
          unique: 0,
          max: 250,
          min: 0
        },
        {
          actual_label: "Currency Code",
          excel_label: "",
          field_name: "cus_currency",
          is_required: true,
          datatype: "select",
          unique: 0,
          max: 0,
          min: 0
        },
        {
          actual_label: "GST Treatment",
          excel_label: "",
          field_name: "cus_gst_type",
          is_required: true,
          datatype: "select",
          unique: 0,
          max: 0,
          min: 0
        },
        {
          actual_label: "GST Identification Number (GSTIN)",
          excel_label: "",
          field_name: "cus_gst_no",
          is_required: false,
          datatype: "text",
          unique: 0,
          max: 30,
          min: 0
        },
        {
          actual_label: "PAN Number",
          excel_label: "",
          field_name: "cus_pan_no",
          is_required: false,
          unique: 0,
          datatype: "text",
          max: 30,
          min: 0
        },
        {
          actual_label: "Payment Terms",
          excel_label: "",
          field_name: "cus_pymnt_term",
          is_required: true,
          datatype: "select",
          unique: 0,
          max: 0,
          min: 0
        },
        {
          actual_label: "Billing Address line1",
          excel_label: "",
          field_name: "cus_billing_addr_line_1",
          is_required: false,
          datatype: "text",
          unique: 0,
          max: 200,
          min: 0
        },
        {
          actual_label: "Billing Address line2",
          excel_label: "",
          field_name: "cus_billing_addr_line_2",
          is_required: false,
          datatype: "text",
          unique: 0,
          max: 200,
          min: 0
        },
        {
          actual_label: "Billing City",
          excel_label: "",
          field_name: "cus_billing_city",
          is_required: false,
          datatype: "text",
          unique: 0,
          max: 30,
          min: 0
        },
        {
          actual_label: "Billing State",
          excel_label: "",
          field_name: "cus_billing_state",
          is_required: false,
          datatype: "select",
          unique: 0,
          max: 0,
          min: 0
        },
        {
          actual_label: "Billing Country",
          excel_label: "",
          field_name: "cus_billing_country",
          is_required: false,
          datatype: "select",
          unique: 0,
          max: 0,
          min: 0
        },
        {
          actual_label: "Billing Pincode",
          excel_label: "",
          field_name: "cus_billing_pincode",
          is_required: false,
          unique: 0,
          datatype: "text",
          max: 10,
          min: 0
        },
        {
          actual_label: "Shipping Address line1",
          excel_label: "",
          field_name: "cus_shipping_addr_line_1",
          is_required: false,
          unique: 0,
          datatype: "text",
          max: 200,
          min: 0
        },
        {
          actual_label: "Shipping Address line2",
          excel_label: "",
          field_name: "cus_shipping_addr_line_2",
          is_required: false,
          unique: 0,
          datatype: "text",
          max: 200,
          min: 0
        },
        {
          actual_label: "Shipping City",
          excel_label: "",
          field_name: "cus_shipping_city",
          is_required: false,
          unique: 0,
          datatype: "text",
          max: 30,
          min: 0
        },
        {
          actual_label: "Shipping State",
          excel_label: "",
          field_name: "cus_shipping_state",
          is_required: false,
          unique: 0,
          datatype: "select",
          max: 0,
          min: 0
        },
        {
          actual_label: "Shipping Country",
          excel_label: "",
          field_name: "cus_shipping_country",
          is_required: false,
          unique: 0,
          datatype: "select",
          max: 0,
          min: 0
        },
        {
          actual_label: "Shipping Pincode",
          excel_label: "",
          field_name: "cus_shipping_pincode",
          is_required: false,
          unique: 0,
          datatype: "text",
          max: 10,
          min: 0
        },
        // {
        //   actual_label: "Customer tags",
        //   excel_label: "",
        //   field_name: "cus_tags",
        //   is_required: false,
        //   unique: 0,
        //   datatype: "array",
        //   max: 0,
        //   min: 0
        // },
        {
          actual_label: "Place of Supply",
          excel_label: "",
          field_name: "place_of_supply",
          is_required: true,
          unique: 0,
          datatype: "select",
          max: 0,
          min: 0
        },
        {
          actual_label: "Opening Balance",
          excel_label: "",
          field_name: "opening_balance",
          is_required: false,
          unique: 0,
          datatype: "text",
          max: 100000000000000,
          min: 0
        },
        {
          actual_label: "Exempt Reason",
          excel_label: "",
          unique: 0,
          field_name: "exempt_reason",
          is_required: false,
          datatype: "text",
          max: 50,
          min: 0
        }
      ];
    },
    submit() {
      this.$store.dispatch("customer/importCustomer", this.list).then(() => {
        this.$router.push({
          name: "Customer"
        });
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: this.message,
          type: "success",
          showCloseButton: true
        });
      });
    }
  },
  computed: {
    ...mapState({
      enablepricelist: state => state.permission.price_list,
      message: state => state.customer.message,
      list: state => state.customer.list
    }),
    ...mapGetters(["cus_settings_details"])
  }
};
</script>